import React from "react";
import { FiMenu, FiSearch, FiBell } from "react-icons/fi";

const Header = ({ toggleSidebar }) => {
  const today = new Date().toLocaleDateString("en-IN", {
    weekday: "short",
    day: "numeric",
    month: "short",
    year: "numeric",
  });

  return (
    <header className="billr-header">
      <div className="billr-header-left">
        <button type="button" className="billr-menu-btn" onClick={toggleSidebar} aria-label="Menu">
          <FiMenu size={20} />
        </button>
        <div className="billr-search">
          <FiSearch />
          <input type="search" placeholder="Search transactions, users, invoices..." />
        </div>
      </div>
      <div className="billr-header-right">
        <span className="billr-header-badge">🇮🇳 INR · {today}</span>
        <button type="button" className="billr-menu-btn d-none d-md-flex" aria-label="Notifications">
          <FiBell size={18} />
        </button>
        <div className="billr-avatar" title="Admin">A</div>
      </div>
    </header>
  );
};

export default Header;
